module.exports = __webpack_public_path__ + "img/espadin.244a8bf0.jpg";